module.exports = __webpack_public_path__ + "static/media/MBVision_cover@2x.7b8d2c20.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/medibank/MBVision_cover@2x.png
// module id = 213
// module chunks = 0